<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @pdCosts="pdCosts"
      @reload="reload"
    >
      <div slot="header" class="order-goods-table-header">
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{
              this.$l('INDEX.pane_label_production_order_goods_info') ||
                '产品信息'
            }}
          </span>
        </div>
        <div style="display: flex;align-items: center;margin-right: 12px;">
          <vxe-button @click="$refs.main.setAllTreeExpand()" circle>
            <i class="fa fa-angle-double-down" style="font-size: 16px;" />
          </vxe-button>
          <vxe-button @click="$refs.main.clearTreeExpand()" circle>
            <i class="fa fa-angle-double-up" style="font-size: 16px;" />
          </vxe-button>
        </div>
      </div>
    </page-main>

    <GoodsPdCostsDrawer
      :disabled="disabled"
      :visible.sync="goodsPdCostsDrawerOptions.visible"
      :pdCostsOrderGoodsCode="goodsPdCostsDrawerOptions.pdCostsOrderGoodsCode"
      @reload="reload"
    />
    <GoodsSpecPdCostsDrawer
      :disabled="disabled"
      :visible.sync="goodsSpecPdCostsDrawerOptions.visible"
      :pdCostsOrderGoodsSpecCode="goodsSpecPdCostsDrawerOptions.pdCostsOrderGoodsSpecCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import GoodsPdCostsDrawer from '../goods-pd-costs-drawer'
import GoodsSpecPdCostsDrawer from '../goods-spec-pd-costs-drawer'
export default {
  components: { PageMain, GoodsPdCostsDrawer, GoodsSpecPdCostsDrawer },
  props: {
    pdCostsOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      goodsPdCostsDrawerOptions: {
        visible: false,
        pdCostsOrderGoodsCode: '',
      },
      goodsSpecPdCostsDrawerOptions: {
        visible: false,
        pdCostsOrderGoodsSpecCode: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
      this.$emit('reload')
    },
    async getData() {
      if (!this.pdCostsOrderCode) return
      this.tableData = []
      this.loading = true
      const res = await this.$api
        .pdCostsOrderGoodsTreeApi({ pdCostsOrderCode: this.pdCostsOrderCode })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data || []

      setTimeout(() => {
        this.$refs.main.setAllTreeExpand()
      }, 0)
    },
    pdCosts(data) {
      let { pdCostsOrderGoodsCode, pdCostsOrderGoodsSpecCode } = data

      pdCostsOrderGoodsCode = pdCostsOrderGoodsCode.indexOf('row_') >= 0 ? '' : pdCostsOrderGoodsCode

      this.goodsPdCostsDrawerOptions = {
        visible: !!pdCostsOrderGoodsCode,
        pdCostsOrderGoodsCode,
      }
      this.goodsSpecPdCostsDrawerOptions = {
        visible: !!pdCostsOrderGoodsSpecCode,
        pdCostsOrderGoodsSpecCode,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.order-goods-table-header {
  display: flex;
  justify-content: space-between;
}
</style>
